module.exports = __webpack_public_path__ + "img/blog-01.bf31b764.jpg";